import {fixedNumber} from "../utils/math-util.js";

export const advancedCashbackModel = (data = {}) => {
    const model = data || {};
    return {
        LoyaltyLevel: model.loyaltyLevel || 0,
        SpendBonusPercent: fixedNumber((model?.spendBonusPercent || 0) / 100, 2),
        DeliveryType: model.deliveryType || 0,
    }
}

export const advancedCashback = (data = {}) => {
    const model = data || {};
    return {
        loyaltyLevel: model.loyaltyLevel || 0,
        spendBonusPercent: fixedNumber((model.spendBonusPercent || 0) * 100, 2),
        deliveryType: model.deliveryType || 0,
        id: model.id || 0,
    }
}

export const advancedCashbackEdit = (data = {}) => {
    const model = data || {};
    return {
        loyaltyLevel: model.loyaltyLevel || 0,
        spendBonusPercent: (model.spendBonusPercent || 0),
        deliveryType: model.deliveryType || 0,
        id: model.id || 0,
    }
}